<template>
  <div>
    <v-footer class="footer">
      <span>© 2026 Pitch English. All Rights Reserved</span>
    </v-footer>
  </div>
</template>
<script>
export default {
  name: "CopyRight",
};
</script>
<style scoped>
.footer {
  bottom: 0;
  width: 100%;
  text-align: center;
  padding-bottom: 1rem;
  background-color: transparent;
}
</style>
